export default __webpack_public_path__ + "images/install2.18bea205adc4339cded5caf9fb1cc815.png";